import { ErrorHandler, Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { QfaEventType } from '../enums/event-type.enum';
import { LoggingService } from './logging.service';

/* eslint-disable @typescript-eslint/no-explicit-any */
@Injectable({ providedIn: 'root' })
export class GlobalErrorHandler implements ErrorHandler {
  private readonly displayError = new BehaviorSubject<boolean>(false);
  displayError$ = this.displayError.asObservable();

  private readonly displayErrorMessage = new BehaviorSubject<string>(
    'Something went wrong. Please refresh the page. If the issue persists please call the Chubb Life team on 0508 464 999 for assistance.',
  );
  displayErrorMessage$ = this.displayErrorMessage.asObservable();

  constructor(private readonly loggingService: LoggingService) {}

  showError(): void {
    this.displayError.next(true);
  }

  hideError(): void {
    this.displayError.next(false);
  }

  setMessage(error: any): void {
    this.handleError(error);
    this.displayErrorMessage.next(error);
  }

  handleError(error: any): void {
    this.loggingService.logEvent(QfaEventType.WARNING, `UI Error occurred. Users will view message: ${error.message}`);
  }
}
